import { render, staticRenderFns } from "./PaymentPrepaidSolutions.vue?vue&type=template&id=a770f02e&scoped=true"
import script from "./PaymentPrepaidSolutions.vue?vue&type=script&lang=js"
export * from "./PaymentPrepaidSolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a770f02e",
  null
  
)

export default component.exports